import { DeviceType } from "@app/constants";
import { StatisticalResponse } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _StatisticalService {
  public getStatistical(device_id: string, fromDate: string, page: number) {
    return HttpService.get<StatisticalResponse>("/statistical", {
      queryParams: {
        device_id,
        from_date: fromDate,
        page,
      },
    });
  }
}

const StatisticalService = new _StatisticalService();

export default StatisticalService;
